import {PRODUCT_RECOMMENDATION_AXIOS} from "@/modules/backend-config";

export default {
    getTrainingStatus() {
        return PRODUCT_RECOMMENDATION_AXIOS.get('/status');
    },
    retrainModel() {
        return PRODUCT_RECOMMENDATION_AXIOS.put('/new_model');
    }
}